import { connect } from 'react-redux';
import EditSharedThreatPolicyModal from '../../components/shared_policies/EditSharedThreatPolicyModal';

import { Mixpanel } from '../../lib/Mixpanel';
import {
  saveEditSharedPolicies,
  closeEditThreatModal,
} from '../../actions/shared_policies';

import { getChangedFields } from '../../selectors/smb_account_settings';

const mapStateToProps = state => {
  let disabled = true;

  let changeAccount = false;
  if (state.shared_policies.editFields.updatedAccountSelections.length) {
    if (
      state.shared_policies.editFields.accountSelections.length !==
      state.shared_policies.editFields.updatedAccountSelections.length
    ) {
      changeAccount = true;
    } else {
      let a = state.shared_policies.editFields.accountSelections.map(
        x => x.value
      );
      let b = state.shared_policies.editFields.updatedAccountSelections.map(
        x => x.value
      );
      console.log('the values: ', a, b);
      changeAccount = a.sort().toString() !== b.sort().toString();
    }
  }
  return {
    disabled:
      !Boolean(Object.keys(state.shared_policies.changes).length) &&
      !changeAccount,
    loading: state.shared_policies.editModal.loading,
    showModal: state.shared_policies.editModal.show,
  };
};

const mapDispatchToProps = dispatch => ({
  buttonAction: () => {
    //Mixpanel.track('Advanced Filtering / Add Rule Dialog / Create', {});
    dispatch(saveEditSharedPolicies());
  },
  closeDialog: () => {
    //Mixpanel.track('Advanced Filtering / Add Rule Dialog / Cancel', {});
    dispatch(closeEditThreatModal());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditSharedThreatPolicyModal);
